import React, { useState } from "react";
import { HelpCircle, ChevronRight } from "lucide-react";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/dentlab/src/components/ui/accordion";
import { cn } from "@/dentlab/src/lib/utils/cn";

interface FaqAccordionProps {
	className?: string;
}

export const FaqAccordion: React.FC<FaqAccordionProps> = ({ className }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<div className={className}>
			<button
				className="flex items-center gap-2 w-full text-left"
				onClick={() => setIsExpanded(!isExpanded)}
				data-testid="faq-toggle"
				aria-label="Häufig gestellte Fragen ein-/ausklappen"
				aria-expanded={isExpanded}
			>
				<HelpCircle className="h-4 w-4 text-gray-500" />
				<span className="text-sm font-semibold text-gray-900 flex-1">
					Häufig gestellte Fragen
				</span>
				<ChevronRight
					className={cn(
						"h-4 w-4 text-gray-400 transition-transform duration-200",
						isExpanded && "rotate-90"
					)}
				/>
			</button>

			{isExpanded && (
				<Accordion
					type="single"
					collapsible
					className="w-full mt-2"
				>
					<AccordionItem value="item-1">
						<AccordionTrigger className="text-sm">
							Wie erfolgt die Anmeldung?
						</AccordionTrigger>
						<AccordionContent>
							Die Anmeldung erfolgt unkompliziert über ein
							Einmalpasswort, das per E-Mail zugesandt wird. Pro
							Arbeitsstation müssen Sie sich <b>nur einmal</b>{" "}
							einloggen.
						</AccordionContent>
					</AccordionItem>
					<AccordionItem value="item-2">
						<AccordionTrigger className="text-sm">
							Ist die Nutzung kostenlos?
						</AccordionTrigger>
						<AccordionContent>
							Ja, die Nutzung ist kostenlos. dentCONNECT
							ermöglicht den sicheren Austausch von Daten zwischen
							Zahnarzt und Labor. Dies ist <b>immer kostenlos</b>,
							egal wie stark ihre Nutzung ist.
						</AccordionContent>
					</AccordionItem>
					<AccordionItem value="item-3">
						<AccordionTrigger className="text-sm">
							Wie kann ich Feedback geben oder Fehler melden?
						</AccordionTrigger>
						<AccordionContent>
							<div className="space-y-2">
								<p>
									In der Navigation unten links unter
									&quot;Support&quot; können Sie jederzeit
									unser Support-Team erreichen.
								</p>
								<p>
									Bitte buchen Sie ausserdem eine kostenlose
									Videokonferenz mit uns. dentCONNECT ist erst
									ein Jahr alt und wird rapide an die Wünsche
									der Praxis und des Labors angepasst.
								</p>
							</div>
						</AccordionContent>
					</AccordionItem>
					<AccordionItem value="item-4">
						<AccordionTrigger className="text-sm">
							Wie kann ich digitale Aufträge aufgeben?
						</AccordionTrigger>
						<AccordionContent>
							Gehen Sie zur Auftragserfassung, füllen Sie das
							Standardformular oder die individuellen Formulare
							ihres Labors aus und senden Sie den Auftrag ab.
							Jeder Auftrag hat einen eigenen Chat für den
							sicheren Datenaustausch.
						</AccordionContent>
					</AccordionItem>
					<AccordionItem value="item-5">
						<AccordionTrigger className="text-sm">
							Erhalte ich Notifikationen per E-Mail?
						</AccordionTrigger>
						<AccordionContent>
							Beim Versenden von Daten kann Ihr Labor Ihnen
							automatisch eine E-Mail Notifikation senden.
						</AccordionContent>
					</AccordionItem>
					<AccordionItem value="item-6">
						<AccordionTrigger className="text-sm">
							Wie kann ich Passwort-Login einrichten?
						</AccordionTrigger>
						<AccordionContent>
							Gehen Sie oben links auf ihr Labor und klicken Sie
							&quot;Passwort setzen&quot;. Dort können Sie ein
							Passwort festlegen und auf neuen Geräten zur
							Authentifizierung nutzen.
						</AccordionContent>
					</AccordionItem>
				</Accordion>
			)}
		</div>
	);
};
